import React, { Component } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

class CreatedInvoicesChart extends Component {
  render() {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={this.props.data}
          margin={{
            top: 10,
            right: 30,
            left: 12,
            bottom: 0
          }}
        >
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend
            align="left"
            wrapperStyle={{ marginLeft: "50px" }}
            payload={[
              {
                value: "Total Value",
                type: "square",
                color: "#FF6C60"
              }
            ]}
          />
          <Area
            dataKey="total_value"
            stackId="1"
            stroke="#FF6C60"
            fill="#FFC4BF"
            dot={true}
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}

export default CreatedInvoicesChart;